export const CANAL_VENDA = {
  WEB: "WEB",
  APP: "APP",
  INTEGRACAO: "INTEGRACAO",
  LIFEGROWTH: "LIFEGROWTH",
  MANUAL: "MANUAL",
  VENDEDOR: "VENDEDOR"
};

export const CANAIS_VENDA_TODOS = Object.values(CANAL_VENDA);

export const CANAIS_VENDA_FIXOS = [
  CANAL_VENDA.WEB,
  CANAL_VENDA.APP,
  CANAL_VENDA.INTEGRACAO,
  CANAL_VENDA.MANUAL,
  CANAL_VENDA.VENDEDOR
];

export const CANAIS_VENDA_OPTIONS = [
  { value: CANAL_VENDA.WEB, text: "Site", disabled: true },
  { value: CANAL_VENDA.APP, text: "App", disabled: true },
  { value: CANAL_VENDA.INTEGRACAO, text: "Integração", disabled: true },
  { value: CANAL_VENDA.LIFEGROWTH, text: "LifeGrowth", disabled: false },
  { value: CANAL_VENDA.MANUAL, text: "Venda+", disabled: true },
  { value: CANAL_VENDA.VENDEDOR, text: "Vendedor", disabled: true }
];

export const CANAIS_VENDA_OPTIONS_DESMARCAVEIS = CANAIS_VENDA_OPTIONS.map(
  option => ({ ...option, disabled: false })
);
